import Box from '@mui/material/Box';
import { Trans } from 'react-i18next';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUserOutlined';
import Divider from '@mui/material/Divider';
import UnitDetailContext from "../UnitDetailContext";
import { useNavigate } from "react-router-dom";
import { POLICY_INDEX } from '..';

const policyTypes = [
  "POLIZA_SEGURO",
  "RECIBO_PAGO",
]

export default function() {
  const navigate = useNavigate()
  return (
    <UnitDetailContext.Consumer>
      { context => {
        const handleClose = () => {
          context.open = false
          context.refresh()
        }

        const document = context.unit.documents.filter((it: any) => it.showDownloads && it.documentType.typeDoc.id === context.documentTypeId)
        const getDocument = (doc:any) => {
         if (!doc) alert("El documento seleccionado no se encuentra disponible para descargar")
          else {
            context.open = false
            context.refresh()
            navigate(`/web/unit-detail/${context.unit.numberPlate}/documents/${doc.id}`, { replace: true })
          }
        }

        return (
          <Dialog
            open={context.open}
            onClose={handleClose}
            className="policy-detail-dialog"
          >
            {context.documentTypeId?(
                <Box>
                <Box sx={{margin: '0 5%'}}>
                  <Box sx={{display: 'flex', margin: '32px 0 0'}}>
                    <VerifiedUserIcon className="unit-404-dialog-icon" sx={{marginRight: '12px'}}/>
                    <Box className="unit-404-dialog-title"><Trans i18nKey={`screens.policyDocumentsDialog.title`}></Trans></Box>
                  </Box>
                  <Box className="unit-404-dialog-text" sx={{marginTop: '18px'}}><Trans i18nKey={`screens.policyDocumentsDialog.text`}></Trans></Box>
                  {document.map( (doc:any) => {
                    return (  <Button onClick={() => getDocument(doc)} className="policy-detail-dialog-button" sx={{marginTop: "18px"}}>
                    {doc?.documentType?.subtypeDoc?.name}
                </Button>);
                  })}
                <br></br>
                </Box>
                <Divider/>
                <Box sx={{display: 'flex', justifyContent: 'space-around', margin: '12px 9%'}}>
                  <Button onClick={handleClose} className="policy-detail-dialog-cancel-button">
                      <Trans i18nKey={`screens.policyDocumentsDialog.cancelButton`}></Trans>
                  </Button>
                </Box>
              </Box>
            )
            :(
              <Box>
              <Box sx={{margin: '0 5%'}}>
                <Box sx={{display: 'flex', margin: '32px 0 0'}}>
                  <VerifiedUserIcon className="unit-404-dialog-icon" sx={{marginRight: '12px'}}/>
                  <Box className="unit-404-dialog-title">
                  El documento seleccionado no se encuentra disponible para descargar
                    </Box>
                </Box>
               
              <br></br>
              </Box>
              <Divider/>
              <Box sx={{display: 'flex', justifyContent: 'space-around', margin: '12px 9%'}}>
                <Button onClick={handleClose} className="policy-detail-dialog-cancel-button">
                    Cerrar
                </Button>
              </Box>
            </Box>
            )}
          
          </Dialog>
        )
      }}
    </UnitDetailContext.Consumer>
  )
}